import { popup } from './popup';
export function popupsInit() {
    const allOpenPopupBtns = document.querySelectorAll('[data-role="open-popup"]');
    const mobileOpenBtn = document.querySelector('.js-mobile-menu-btn');
    const mobileHeaderContent = document.querySelector('.site-header__content');
    allOpenPopupBtns.forEach((openPopupBtn) => {
        const popupToOpenId = openPopupBtn.dataset.target;
        popup(`[data-target="${popupToOpenId}"]`, `#${popupToOpenId}`, '[data-role="close-popup"]');
        mobileOpenBtn &&
            mobileOpenBtn.addEventListener('click', function (e) {
                if (!mobileOpenBtn.classList.contains('active')) {
                    document.body.style.overflow = 'visible';
                }
                if (mobileHeaderContent) {
                    if (mobileHeaderContent.classList.contains('active')) {
                        mobileHeaderContent.style.overflow = 'scroll';
                    }
                    else {
                        mobileHeaderContent.style.overflow = '';
                    }
                }
            });
    });
    const allMenuItemsWithSubItems = document.querySelectorAll('#main-menu_mobile .menu-item-has-children');
    allMenuItemsWithSubItems.forEach((menuItem) => {
        const menuItemID = menuItem.id;
        if (menuItemID != '') {
            popup(`#${menuItemID} > a`, `#${menuItemID} > .sub-menu`, false, 'accordion');
        }
    });
}
export const initBlockVideo = () => {
    const players = document.querySelectorAll('.js-player-autoplay iframe');
    [...players].forEach((player) => {
        const ifrmeUrl = player.src;
        if (ifrmeUrl) {
            const urlParams = '&autoplay=1&loop=1&muted=1&title=0&portrait=0&byline=0&controls=1';
            player.src = ifrmeUrl + urlParams;
        }
    });
};
